import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ChazkiLogo from 'constants/chazki-logo.png';
import Logo from 'constants/paquery-logo-blue.png';
import { authIsLoginSelector } from 'redux/auth/selectors';
import { actions } from 'redux/auth/slice';
import API from 'constants/api';
import { ConfigProvider } from 'antd';
import LoginForm from '@paquery-team/lib-loginform';

const URL = {
  recover: API.auth.recover,
  confirm: API.auth.confirm,
};

const Login = () => {
  const dispatch = useDispatch();
  const isLoginIn = useSelector(authIsLoginSelector);
  const submitLogin = useCallback(
    (values) => {
      dispatch(actions.fetch(values));
    },
    [dispatch],
  );
  const submit = {
    login: submitLogin,
  };

  const CHAZKI_BACKGROUND = '#ffffff';
  const CHAZKI_BLUE = '#257de2';

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: CHAZKI_BLUE,
          colorBgBase: CHAZKI_BACKGROUND,
        },
      }}
    >
      <LoginForm
        applicationName="Marketplaces"
        submit={submit}
        tenantLogo={ChazkiLogo}
        isLogginIn={isLoginIn}
        loginFailure={false}
        URL={URL}
        paqueryLogo={Logo}
      />
    </ConfigProvider>
  );
};

export default Login;
